<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('setupLandingPage.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('setupLandingPage.landingPageType')
                }}</label>
                <div class="col-md-7">
                  <select
                    class="form-control"
                    v-model="model.lpt_id"
                    :class="{ 'is-invalid': errors.has('lpt_id') }"
                    @change="onLandingPageTypeChange"
                  >
                    <option
                      :value="null"
                      disabled
                      selected
                      style="display: none;"
                      >{{ $t('select') }}</option
                    >
                    <option
                      v-for="(lpt, index) in landingPageTypes"
                      :key="index"
                      :value="lpt.lpt_id"
                    >
                      {{ lpt.landing_page_type }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('lpt_id')">
                    {{ errors.first('lpt_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label
                  v-if="model.lpt_id == null"
                  class="col-md-3 col-form-label"
                  >{{ $t('setupLandingPage.objectName') }}</label
                >
                <label
                  v-if="model.lpt_id == 1"
                  class="col-md-3 col-form-label"
                  >{{ $t('setupLandingPage.mainProgram') }}</label
                >
                <label
                  v-if="model.lpt_id == 2"
                  class="col-md-3 col-form-label"
                  >{{ $t('setupLandingPage.subProgram') }}</label
                >
                <label
                  v-if="model.lpt_id == 3"
                  class="col-md-3 col-form-label"
                  >{{ $t('setupLandingPage.corporatePartner') }}</label
                >
                <label
                  v-if="model.lpt_id == 6"
                  class="col-md-3 col-form-label"
                  >{{ $t('setupLandingPage.question') }}</label
                >
                <div class="col-md-7">
                  <select
                    class="form-control"
                    v-if="model.lpt_id == null"
                    :class="{ 'is-invalid': errors.has('lpt_id') }"
                  >
                    <option
                      :value="null"
                      disabled
                      selected
                      style="display: none;"
                      >{{ $t('select') }}</option
                    >
                  </select>
                  <treeselect
                    v-if="model.lpt_id == 1"
                    :load-options="loadMainProgramOptions"
                    :options="mainProgramOptions"
                    :placeholder="$t('setupLandingPage.selectMainProgram')"
                    v-model="model.object_ref_id"
                    :class="{ 'is-invalid': errors.has('object_ref_id') }"
                  />
                  <treeselect
                    v-if="model.lpt_id == 2"
                    :load-options="loadSubProgramOptions"
                    :options="subProgramOptions"
                    :placeholder="$t('setupLandingPage.selectSubProgram')"
                    v-model="model.object_ref_id"
                    :class="{ 'is-invalid': errors.has('object_ref_id') }"
                  />
                  <treeselect
                    v-if="model.lpt_id == 3"
                    :load-options="loadPartnerOptions"
                    :options="partnerOptions"
                    :placeholder="$t('setupLandingPage.selectPartner')"
                    v-model="model.object_ref_id"
                    :class="{ 'is-invalid': errors.has('object_ref_id') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('lpt_id')">
                    {{ errors.first('lpt_id') }}
                  </div>
                  <textarea
                    rows="3"
                    class="form-control"
                    v-if="model.lpt_id == 6"
                    :placeholder="$t('setupLandingPage.enterQuestion')"
                    v-model="model.logo"
                    :class="{ 'is-invalid': errors.has('logo') }"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="model.lpt_id != 6">
            <div class="col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label"></label>
                <div class="col-md-7">
                  <div id="img-frame" class="text-center">
                    <label for="logo_file" id="label_logo_file">
                      <img :src="logo_file_src" alt="" />
                    </label>
                    <input
                      type="file"
                      id="logo_file"
                      ref="logo_file"
                      accept="image/*"
                      @change="onFileSelected"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <label v-if="model.lpt_id != 6" class="col-form-label required">{{
                $t('setupLandingPage.description')
              }}</label>
              <label v-if="model.lpt_id == 6" class="col-form-label required">{{
                $t('setupLandingPage.answer')
              }}</label>
              <VueEditor
                v-model="model.description"
                :editor-toolbar="customToolbar"
                useCustomImageHandler
                @imageAdded="handleImageAdded"
              />
                <!-- :editorOptions="editorSettings" -->
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12 text-right">
              <ts-button
                class="btn-default mr-2"
                @click.prevent="$emit('close')"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                color="primary"
                outline
                :waiting="saving_new"
                @click.prevent="saveAddNew"
                >{{ $t('save_add_new') }}</ts-button
              >
              <ts-button
                class="btn-primary ml-2"
                @click.prevent="store"
                :waiting="saving"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'

// will implement next time drop and resize
// import { ImageDrop } from 'quill-image-drop-module'
// import ImageResize  from 'quill-image-resize-module'

// Quill.register('modules/imageDrop', ImageDrop)
// Quill.register('modules/imageResize', ImageResize)

export default {
  name: 'landingPageCreate',
  components: { VueEditor },
  data() {
    return {
      model: {
        id: 0,
        logo: '',
        lpt_id: null,
        object_ref_id: null,
        description: ''
      },
      errors: new Errors(),
      file: '',
      defaultImage: require('../../assets/cover-default-image.png'),
      defaultLogo: require('../../assets/default-logo.png'),
      logo_file_src: require('../../assets/cover-default-image.png'),
      saving: false,
      saving_new: false,
      loadingPreData: false,
      mainProgramOptions: null,
      subProgramOptions: null,
      partnerOptions: null,
      // editorSettings: {
      //   modules: {
      //     imageDrop: true,
      //     imageResize: {}
      //   }
      // },
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('setupLandingPage', ['landingPageTypes'])
  },
  methods: {
    onLandingPageTypeChange() {
      this.model.object_ref_id = null
      if (this.model.lpt_id == 6) {
        this.model.logo = ''
        this.file = this.defaultImage
      }
      if (this.model.lpt_id == 3 || this.model.lpt_id == 4) {
        this.model.logo = ''
        this.file = this.defaultLogo
        this.logo_file_src = this.defaultLogo
      } else {
        this.file = this.defaultImage
        this.logo_file_src = this.defaultImage
      }
    },
    async getMainProgram() {
      this.mainProgramOptions = null
      await this.$store
        .dispatch('setupLandingPage/fetchMainProgram')
        .then(response => {
          this.mainProgramOptions = response.data.map(el => ({
            id: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async getSubProgram() {
      this.subProgramOptions = null
      await this.$store
        .dispatch('setupLandingPage/fetchSubProgram')
        .then(response => {
          this.subProgramOptions = response.data.map(el => ({
            id: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async getPartner() {
      this.partnerOptions = null
      await this.$store
        .dispatch('setupLandingPage/fetchCorporatePartner')
        .then(response => {
          this.partnerOptions = response.data.map(el => ({
            id: el.cpp_id,
            label: el.partner_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async loadMainProgramOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getMainProgram()
      }
    },
    async loadSubProgramOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getSubProgram()
      }
    },
    async loadPartnerOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getPartner()
      }
    },
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('setupLandingPage/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loadingPreData = false
        })
    },
    onFileSelected() {
      const file = this.$refs.logo_file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.logo_file_src = this.defaultImage

          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },
    uploadPhoto() {
      if (this.$refs.logo_file) {
        this.file = this.$refs.logo_file.files[0]
          ? this.$refs.logo_file.files[0]
          : null
        if (this.file) {
          let formData = new FormData()
          formData.append('logo', this.file)
          return this.$store.dispatch('setupLandingPage/uploadPhoto', formData)
        }
      }

      return this.model.logo
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('image_content', file)
      this.$store
        .dispatch('setupLandingPage/imageContent', formData)
        .then(response => {
          Editor.insertEmbed(cursorLocation, 'image', response)
          resetUploader()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async store() {
      this.errors = new Errors()
      this.saving = true
      let logo_path = await this.uploadPhoto()
      this.$store
        .dispatch(
          'setupLandingPage/store',
          Object.assign({}, this.model, { logo: logo_path })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    async saveAddNew() {
      this.errors = new Errors()
      this.saving_new = true
      let logo_path = await this.uploadPhoto()
      this.$store
        .dispatch(
          'setupLandingPage/store',
          Object.assign({}, this.model, { logo: logo_path })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.clearForm()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearForm() {
      this.model = {
        id: 0,
        logo: '',
        lpt_id: null,
        object_ref_id: null,
        description: ''
      }
    }
  }
}
</script>
<style scoped>
#logo_file {
  display: none;
}
#img-frame img {
  object-fit: contain;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
#label_logo_file {
  cursor: pointer;
}
</style>
